import PassFail from './PassFailGrading';

export default PassFail;
